import * as types from './locationActionTypes';

export const getLocations = pageId => ({
  type: types.GET_LOCATION_REQUEST,
  pageId,
});



// WEBPACK FOOTER //
// ./src/store/location/locationActions.js